import React from 'react';
import styled from 'styled-components';
import { Element } from 'react-scroll';
import { Title1 } from '../../../components/Typography';
import ComboPreview from './components/ComboPreview';

const Wrapper = styled(Element)`
  display: grid;
  grid-gap: 30px;
  padding-bottom: 64px;

  @media (max-width: 786px) {
    padding-bottom: 28px;
  }
`

const ComboHeading = styled(Title1)`
  margin-top: ${props => (props.isOffersEnabled ? '0' : '20px')};
  width: max-content;
  font-weight: 600;

  :after {
    content: ""; 
    display: block; 
    width: calc(100% + 2px);
    padding-top: 2px; 
    border-bottom: ${props => props.categoriesBarSelectedBorderColorWidth} solid
       ${props => props.theme.categoriesBarSelectedBorderColor};
  }
`

const ComboWrapper = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    `repeat(${props.theme.productPreviewsPerRow}, 1fr)`};
  grid-gap: 24px;
  @media (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`

const ComboList = ({combos, handleComboPreviewClick}) => {
  return (
    combos.length > 0 &&
    <Wrapper>
      <ComboHeading>Combos</ComboHeading>
      <ComboWrapper>
        {
          combos.map(combo => {
            return <ComboPreview
              key={`combo-${combo.id}`}
              combo={combo}
              handleComboPreviewClick={handleComboPreviewClick}
            />
          })
        }
      </ComboWrapper>
    </Wrapper>
  )
}

export default ComboList
